import { createSlice } from "@reduxjs/toolkit";

const promoterListSlice = createSlice({
    name : "promoter",
    initialState:{

        list: []
    },
    reducers:{
        createpromoternamelist (state, action){
            // console.log(action)
            // state.list.push([...state, action.payload])
            state.list =  action.payload
            // console.log(` Inside the store ${state.list}`)
        }
    }

})

export const promoterListActions = promoterListSlice.actions
export default promoterListSlice